import { AxiosError } from "axios";

export const getAxiosErrorMessage = (error: unknown): string | undefined => {
  if (error instanceof AxiosError && error.response?.data && typeof error.response.data === "object") {
    const message = (error.response.data as Record<string, unknown>).message;
    if (typeof message === "string") {
      return message;
    }
  }
  return "Une erreur est survenue. Veuillez contacter un administrateur";
};

export const getAxiosErrorCause = (error: unknown): string | undefined => {
  if (error instanceof AxiosError && error.response?.data && typeof error.response.data === "object") {
    const cause = (error.response.data as Record<string, unknown>).cause;
    if (typeof cause === "string") {
      return cause;
    }
    if (cause && typeof cause === "object") {
      const maybeMessage = (cause as Record<string, unknown>).message;
      if (typeof maybeMessage === "string") {
        return maybeMessage;
      }
    }
  }
  return undefined;
};

export const getAxiosError = (error: unknown): string | undefined => {
  return getAxiosErrorCause(error) || getAxiosErrorMessage(error);
};
